/* eslint-disable */
function bindTabs() {

  var $tabs = $('.dcg-simple-tabs').find('.tabs a');
  var $tab1 = $('a.mcd-desktop-tab1');
  var $tabContent1 = $('div.mcd-desktop-tab1');
  var $tab2 = $('a.mcd-desktop-tab2');
  var $tabContent2 = $('div.mcd-desktop-tab2');

  $tabs.off('click').on('click', function(e) {

    var currentTarget = $(e.currentTarget);

    if (currentTarget.hasClass('disabled')) {
      return false;
    }

    if (currentTarget.hasClass('mcd-desktop-tab1')) {
      $tab1.addClass('active');
      $tabContent1.show();
      $tab2.removeClass('active');
      $tabContent2.hide();
    } else {
      $tab2.addClass('active');
      $tabContent2.show();
      $tab1.removeClass('active');
      $tabContent1.hide();
    }
    e.preventDefault();
  });
}

module.exports = {
  bindTabs: bindTabs
};
